'use strict';

angular.module('mean.projects').factory('costTotalService', ['$filter',
    function($filter) {
        //getTotal takes a ProjectHours object
        var getTotal = function(item) {
            var base = item.hours * item.rate;
            var over = item.hours_over_time * item.rate * 0.5;
            var double = item.hours_double_time * item.rate;

            return base + over + double + item.production_bonus + 
                item.extra_break_money + item.premium_overtime;
        };

        var getPayrollTaxes = function(labor, costs) {
            return labor * costs.payroll_taxes;
        };

        var getWorkersComp = function(user, costs) {
            var labor = user.hours * user.rate;
            labor += user.production_bonus;
            labor += user.extra_break_money;

            return (user.rate<costs.w_comp_break) ? 
                labor * costs.w_comp_high : labor * costs.w_comp_low;
        };

        var getBreakTime = function(hours) {
            var minutes = hours * 60;
            var prod = 0;

            if(minutes >= 210 && minutes <= 360) //greater than 3.5 and less than 6
                prod = 10 / minutes;
            else if(minutes > 360 && minutes <= 600) //greater than 6 and less than 10
                prod = 20 / minutes;
            else if(minutes > 600) //greater than 10 hours
                prod = 30 / minutes;

            return prod;
        };

        var getUnproductiveTime = function(hours) {
            return hours * getBreakTime(hours);
        };

        var getProductiveTime = function(hours, user) {
            return hours - getUnproductiveTime(hours, user);
        };

        /* total_wages is the sum of all wages over the time period
         */
        var getEffectiveRate = function(total_wages, production_bonus, productive_time) {
            return (total_wages + production_bonus) / productive_time;
        };

        var getDiff = function(average_rate, total_wages, production_bonus, hours, user) {
            return getEffectiveRate(total_wages, production_bonus, hours, user) - average_rate;
        };

        var getExtraRest = function(average_rate, total_wages, production_bonus, hours, user) {
            return getDiff(average_rate, total_wages, production_bonus, hours, user) * getUnproductiveTime(hours, user);
        };

        var getExtraBreakMoney = function(average_rate, total_wages, production_bonus, hours, user) {
            var total_hours = 40; //hard coded for now but needs to change
            return getExtraRest(average_rate, total_wages, production_bonus, hours, user) *
                (hours / total_hours);
        };

        var getPremiumOvertime = function(average_rate, total_wages, production_bonus, hours, user) {
            var extra_rest = getExtraRest(average_rate, total_wages, production_bonus, hours, user);
            return (user.hours_over_time * extra_rest * 0.5) 
                + (user.hours_double_time * extra_rest);
        }

        return {
            getTotal: getTotal,
            getPayrollTaxes: getPayrollTaxes,
            getWorkersComp: getWorkersComp,
            getBreakTime: getBreakTime,
            getUnproductiveTime: getUnproductiveTime,
            getProductiveTime: getProductiveTime,
            getEffectiveRate: getEffectiveRate,
            getDiff: getDiff,
            getExtraRest: getExtraRest,
            getExtraBreakMoney: getExtraBreakMoney,
            getPremiumOvertime: getPremiumOvertime
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/cost-total-service.js